// Components
import { LegalPageContent } from '../../components/LegalPageContent/LegalPageContent';

export const DataTransferAddendumPage = () => {
  return <LegalPageContent slug="data-transfer-addendum" fallbackTitle="Data Transfer Addendum" />;
};
